// @flow
export const TEXT_INPUT_TYPE = 'text';
export const CHECKBOX_INPUT_TYPE = 'checkbox';
export const TEXT_NUMBER_INPUT_TYPE = 'number';
export const DATE_INPUT_TYPE = 'date';
export const SELECT_INPUT_TYPE = 'select';
export const BOOLEAN_SELECT_INPUT_TYPE = 'booleanSelect';
export const FILE_INPUT_TYPE = 'file';
